import React, { useState } from 'react';
import CalcShell from '../CalcShell';

// Common weight/mass units → grams (extended set)
const UNITS = {
  'attogram (ag)': 1e-18, 'femtogram (fg)': 1e-15, 'picogram (pg)': 1e-12,
  'nanogram (ng)': 1e-9, 'microgram (µg)': 1e-6, 'milligram (mg)': 0.001,
  'gram (g)': 1, 'kilogram (kg)': 1000, 'metric ton (t)': 1e6,
  'gigagram (Gg)': 1e9, 'teragram (Tg)': 1e12, 'petagram (Pg)': 1e15, 'exagram (Eg)': 1e18,
  'ounce (oz)': 28.3495, 'pound (lb)': 453.592, 'stone (st)': 6350.29,
  'short ton (US)': 907185, 'long ton (UK)': 1016047,
  'grain (gr)': 0.06479891, 'carat (ct)': 0.2, 'slug': 14593.9,
  'atomic mass unit (u)': 1.66054e-24
};

export default function WeightConverterCalc() {
  const [value, setValue] = useState(70);
  const [from, setFrom] = useState('kg');
  const grams = Number(value) * UNITS[from];
  return (
    <CalcShell look="cnet" title="Weight Converter" subtitle="Fast conversion between kilograms, pounds, ounces, stones, tonnes and more.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Value</label><input type="number" value={value} onChange={e => setValue(e.target.value)}/></div>
          <div className="field"><label>From</label>
            <select value={from} onChange={e => setFrom(e.target.value)}>{Object.keys(UNITS).map(u => <option key={u}>{u}</option>)}</select>
          </div>
        </div>
        <div>
          <table className="data-table">
            <thead><tr><th>Unit</th><th className="text-right">Value</th></tr></thead>
            <tbody>{Object.entries(UNITS).map(([u,k]) => (
              <tr key={u}><td>{u}</td><td className="text-right font-mono">{(grams/k).toLocaleString('en-US',{maximumFractionDigits:6})}</td></tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </CalcShell>
  );
}
